var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modal-conf","size":"lg","hide-header-close":true,"no-close-on-esc":true,"no-close-on-backdrop":true},scopedSlots:_vm._u([{key:"modal-header",fn:function(ref){
var close = ref.close;
return [_c('h5',[_vm._v("Atenção")])]}},{key:"default",fn:function(ref){
var hide = ref.hide;
return [_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.mensagem)}})])]}},{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
return [_c('b-button',{staticClass:"mr-auto",attrs:{"size":"lg","variant":"danger"},on:{"click":function($event){return _vm.devolveResposta('n')}}},[_vm._v("Recusar")]),_c('b-button',{attrs:{"size":"lg","variant":"success"},on:{"click":function($event){return _vm.devolveResposta('s')}}},[_vm._v("Aceitar")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }